var SearchBlock;
(function (SearchBlock) {
    myonce('searchBlock', () => {
        const $search = document.querySelector('#search-block');
        const $triggers = document.querySelectorAll('[data-search-block]');
        if ($search && $triggers.length) {
            const $form = $search.querySelector('form');
            const $input = $form.querySelector('input');
            const $autocomplete = $search.querySelector('.autocomplete');
            const $recent = $search.querySelector('.recent');
            const $mask = $search.querySelector('.mask');
            init();
            $triggers.forEach(($trigger) => {
                $trigger.addEventListener('click', () => {
                    open($search, $trigger);
                });
            });
            function init() {
                localforage.getItem('recent-searches')
                    .then((searches) => {
                    if (searches && searches.length) {
                        searches.forEach((search) => {
                            const $item = document.createElement('div');
                            const $icon = document.createElement('i');
                            $icon.classList.add('icn');
                            $icon.classList.add('icn-close');
                            $item.innerText = search;
                            $item.appendChild($icon);
                            $item.classList.add('search-item');
                            $recent.appendChild($item);
                            $item.addEventListener('click', (e) => {
                                var _a;
                                if (e.currentTarget === e.target) {
                                    $input.value = search;
                                    trigger($form, 'submit');
                                }
                                else {
                                    removeRecent(search);
                                    $item.remove();
                                    (_a = document.querySelector('.open')) === null || _a === void 0 ? void 0 : _a.removeEventListener;
                                }
                            });
                        });
                    }
                    else {
                        $recent.remove();
                    }
                });
                $form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    addRecent($input.value)
                        .then(() => {
                        e.target.submit();
                    });
                });
                $input.addEventListener('keyup', debounce(() => {
                    $autocomplete.innerHTML = '';
                    autocomplete($input.value);
                }, 250));
            }
            function open($search, $bound) {
                var _a;
                if ($bound.getAttribute('data-search-block') === 'next') {
                    $bound.parentNode.insertBefore($search, $bound.nextSibling);
                }
                else {
                    $bound.parentNode.appendChild($search);
                }
                $search.classList.add('is-active');
                (_a = document.querySelector('.open')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                    if (document.querySelector('#input-search-filed-header').value != '') {
                        $form === null || $form === void 0 ? void 0 : $form.submit();
                    }
                });
                $input.focus();
            }
            function addRecent(term) {
                return localforage.getItem('recent-searches')
                    .then((searches) => {
                    searches = searches || [];
                    if (term && !searches.includes(term)) {
                        searches.push(term);
                        if (searches.length > 5) {
                            searches.shift();
                        }
                        localforage.setItem('recent-searches', searches);
                    }
                });
            }
            function removeRecent(term) {
                return localforage.getItem('recent-searches')
                    .then((searches) => {
                    if (searches && searches.length) {
                        const i = searches.indexOf(term);
                        if (i >= 0) {
                            searches.splice(i, 1);
                            localforage.setItem('recent-searches', searches);
                            if (!searches.length) {
                                $recent.remove();
                            }
                        }
                    }
                });
            }
            function close($search) {
                $search.classList.remove('is-active');
            }
            function autocomplete(value) {
                if (value && value.length >= 3) {
                    Fetch('/search_api_autocomplete/autocomplete', {
                        method: 'GET',
                        data: {
                            display: 'default',
                            filter: 'search_api_fulltext',
                            q: value,
                            token: true,
                        }
                    }).then((response) => {
                        if (response && response.length) {
                            response.forEach((result) => {
                                const $item = document.createElement('div');
                                const $icon = document.createElement('i');
                                const $span = document.createElement('span');
                                let value = result.value || '';
                                value = value[0].toUpperCase() + value.slice(1);
                                value = value.replace(/<([^>]+?)([^>]*?)>/ig, "");
                                $span.innerText = value;
                                $item.classList.add('suggestion');
                                $icon.classList.add('icn');
                                $icon.classList.add('icn-search');
                                $item.appendChild($icon);
                                $item.appendChild($span);
                                $autocomplete.appendChild($item);
                                $item.addEventListener('click', () => {
                                    $input.value = value;
                                    trigger($form, 'submit');
                                });
                            });
                            $autocomplete.classList.add('is-active');
                        }
                        else {
                            disable();
                        }
                    }).catch(() => {
                        disable();
                    });
                }
                else {
                    disable();
                }
                function disable() {
                    $autocomplete.innerHTML = '';
                    $autocomplete.classList.remove('is-active');
                }
            }
        }
    });
})(SearchBlock || (SearchBlock = {}));
